"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var product_1 = require("../../ducks/product");
var is_admin_1 = require("../../ducks/is-admin");
var withErrorBoundary_1 = __importDefault(require("../../../../decorators/withErrorBoundary"));
var author_module_scss_1 = __importDefault(require("./author.module.scss"));
var Author = function () {
    var _a = (0, react_redux_1.useSelector)(product_1.authorSelector), name = _a.name, storePath = _a.storePath, inventoryPath = _a.inventoryPath;
    var isAdmin = (0, react_redux_1.useSelector)(is_admin_1.isAdminSelector);
    var shutterStockAuthor = (0, react_redux_1.useSelector)(product_1.productShutterstockAuthorSelector);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: author_module_scss_1.default.root },
            react_1.default.createElement("span", { className: author_module_scss_1.default.label }, "\u0414\u0438\u0437\u0430\u0439\u043D\u0435\u0440:"),
            react_1.default.createElement("a", { href: storePath, className: author_module_scss_1.default.value }, name),
            isAdmin && (react_1.default.createElement("a", { href: inventoryPath, className: author_module_scss_1.default.inventory }, "(\u0418\u043D\u0432\u0435\u043D\u0442\u0430\u0440\u044C)"))),
        shutterStockAuthor && (react_1.default.createElement("div", { className: author_module_scss_1.default.root },
            react_1.default.createElement("span", { className: author_module_scss_1.default.label }, "\u0410\u0432\u0442\u043E\u0440 \u0444\u043E\u0442\u043E Shutterstock:"),
            react_1.default.createElement("span", { className: author_module_scss_1.default.value }, shutterStockAuthor)))));
};
exports.default = (0, withErrorBoundary_1.default)(Author);
